/* global globalThis */

export function createHttpAdvancedAstrologyClient({
  baseUrl = '/api/advanced-astrology/snapshot',
  fetchImpl = globalThis.fetch?.bind(globalThis),
} = {}) {
  if (typeof fetchImpl !== 'function') throw new Error('A Fetch-compatible implementation is required.');

  return {
    async loadSnapshot(params, { signal } = {}) {
      const url = new URL(baseUrl, globalThis.location?.origin || 'http://localhost');
      for (const [key, value] of Object.entries(params || {})) {
        if (value === undefined || value === null || value === '') continue;
        url.searchParams.set(key, String(value));
      }
      const response = await fetchImpl(url, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        signal,
      });
      if (!response.ok) {
        const body = await response.text().catch(() => '');
        throw new Error(body || `Advanced astrology tools API returned ${response.status}.`);
      }
      return response.json();
    },
  };
}

export function createFunctionClient(loader) {
  if (typeof loader !== 'function') throw new TypeError('loader must be a function.');
  return {
    loadSnapshot: (params, options) => Promise.resolve(loader(params, options)),
  };
}
